/**
 * 회원 캐시 내역 (/adm/member/cash) — 기간·회원·지사·구분·사유로 캐시 원장을 본다
 * ($j.Pages.Admin.MemberCash / body data-page-name="MemberCash")
 *
 * 지사 목록·사유 이름표는 컨트롤러가 #page-data 로 넘긴다.
 */
export default class MemberCash {
    initialize() {
        const PAGE = JSON.parse(document.getElementById('page-data').textContent);
        let $table = null;
        const today = dayjs();
        const aWeekAgo = today.subtract(1, 'week');

        // 시작일, 종료일 input에 날짜 값 넣기
        $('#start_date').val(aWeekAgo.format('YYYY-MM-DD'));
        $('#end_date').val(today.format('YYYY-MM-DD'));

        // 검색 버튼 클릭 이벤트
        $('#searchBtn').click(function() {
            $table.ajax.reload();
        });

        // 엑셀 버튼 클릭 이벤트
        $('#excelBtn').on('click', function () {
            saveToExcel_ready('cash-table', '현금내역');
        });

        // 페이지 길이 변경 이벤트
        $('#page_length').change(function() {
            $table.page.len($(this).val()).draw();
        });

        $('#start_date, #end_date').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [], // 설정 버튼 제거
        });

        // 지사 select 세팅
        const gisaList = PAGE.gisaList;
        const gisaSelected = $('#gisa').val();
        $('#gisa').append(
            gisaList.map(item => {
                const selected = item.code === gisaSelected ? 'selected' : '';
                return `<option value="${item.code}" ${selected}>${item.name}</option>`;
            })
        );

        // 구분 select 세팅
        const typeList = ["입금", "출금"];
        const typeSelected = $('#type').val();
        $('#type').append(
            typeList.map(type => {
                const selected = type === typeSelected ? 'selected' : '';
                return `<option value="${type}" ${selected}>${type}</option>`;
            })
        );

        // 사유 select 세팅
        const reasonList = PAGE.reasonList;
        const reasonSelected = $('#reason').val();
        const usedLabels = [];
        $('#reason').append(
            Object.entries(reasonList).reduce((acc, [key, value]) => {
                if (key === 'admin') return acc;

                if (['redbank', 'innopay','deposit', 'withdraw', 'request'].includes(key)) {
                    if (!usedLabels.includes('충전금')) {
                        const selected = reasonSelected === '충전금' ? 'selected' : '';
                        acc.push(`<option value="충전금" ${selected}>충전금</option>`);
                        usedLabels.push('충전금');
                    }
                    return acc;
                }

                if (key.length > 1) {
                    const selected = reasonSelected === key ? 'selected' : '';
                    acc.push(`<option value="${key}" ${selected}>${value}</option>`);
                    usedLabels.push(value);
                }

                return acc;
            }, [])
        );

        $(function () {
            loadTable();

            $('#search_keyword').on('input', function () {
                const $this = $(this);
                let val = $this.val().replace(/[^0-9]/g, '');

                if (/^01[016789]\d{3,8}$/.test(val)) {
                    if (val.length <= 10) {
                        // 10자리 번호 (예: 0101234567 → 010-123-4567)
                        val = val.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
                    } else {
                        // 11자리 번호 (예: 01012345678 → 010-1234-5678)
                        val = val.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
                    }
                    $this.val(val);
                }
            });

            $('#search_keyword').on('keydown', function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault(); // 폼 제출 방지
                    $('#searchBtn').click(); // 검색 버튼 클릭 이벤트 호출
                }
            });

        });

        /**
         * 데이터 테이블 컬럼
         */
        function loadTable() {
            const formatNumber = (number) => {
                return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            };

            const columns = [
                {
                    data: 'num', title: 'NO'
                },
                {data: 'datetime', title: '일시', render: v => $j.Common.Util.formatDateTime(v)},
                {data: 'ordernum', title: '오더번호'},
                {
                    data: 'car_price',
                    title: '오더금액',
                    render: function(data) {
                        return formatNumber(data);
                    }
                },
                {
                    // 회원 표기는 관리자 공용 규약 — `이름#번호` + 회원 팝오버.
                    // 번호가 이름 옆에 붙으므로 아래 '회원코드' 칸은 뺐다
                    data: null,
                    title: '회원',
                    render: (d, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name),
                },
                {
                    data: 'mem_car_type',
                    title: '차종'
                },
                {data: 'gisa_name', title: '지사'},
                {data: 'rel_action', title: '내역'},
                {
                    data: 'point',
                    title: '금액',
                    render: function(data) {
                        return formatNumber(data);
                    }
                },
                {
                    data: 'total_point',
                    title: '캐시포인트',
                    render: function(data) {
                        return formatNumber(data);
                    }
                },

                {
                    data: 'manage_name',
                    title: '작업자',
                    render: function(data, type, row) {
                        return data ? data : ''; // 값이 있으면 보여주고, 없으면 빈칸
                    }
                },
                {data: 'rel_desc', title: '메모'}
            ];

            if ($table) {
                $table.destroy();
                $('#cash-table').empty();  // 테이블 내용을 비워서 초기화
            }

            $table = new DataTable('#cash-table', {
                autoWidth: false,
                columns: columns,
                scrollY: 'calc(100vh / var(--adm-zoom, 1) - 230px)', // 화면 높이에 맞게 동적으로 설정
                scrollCollapse: true,
                scrollX: true,
                headerCallback: (thead) => $(thead).find('th').css('text-align', 'center'),
                // ⚠ 컬럼을 더하거나 빼면 여기 번호도 같이 옮긴다 — 조용히 엉뚱한 칸의 폭이 된다
                columnDefs: [
                    { targets: 0, width: '60px' },    // NO
                    { targets: 1, width: '130px' },   // 일시
                    { targets: 2, width: '80px' },    // 오더번호
                    { targets: 3, width: '100px' },   // 오더금액
                    { targets: 4, width: '140px' },   // 회원 (이름#번호)
                    { targets: 5, width: '100px' },   // 차종
                    { targets: 6, width: '60px' },    // 지사
                    { targets: 7, width: '100px' },   // 사유
                    { targets: 8, width: '90px' },    // 금액
                    { targets: 9, width: '100px' },   // 통장포인트
                    { targets: 10, width: '70px' },   // 작업자
                    { targets: 11, width: '150px' }   // 메모
                ],
                rowCallback: formatRow,
                ajax: {
                    url: '/adm/ajax/member/cash/list',
                    type: 'post',
                    data: function (d) {
                        d.gisa = $('#gisa').val();
                        d.type = $('#type').val();
                        d.reason = $('#reason').val();
                        d.mb_no = $('#member_code').val();
                        d.kwd = $('#search_keyword').val();
                        d.start_date = $('#start_date').val();
                        d.end_date = $('#end_date').val();
                        d.order_num = $('#order_num').val();
                    }
                },
                language: {
                    emptyTable: "데이터가 없습니다.",
                    lengthMenu: "_MENU_ 개씩 보기",
                    info: "총 _TOTAL_ 건 중 _START_ ~ _END_",
                    infoEmpty: "데이터 없음",
                    infoFiltered: "(전체 _MAX_ 건 중 필터)",
                    loadingRecords: "로딩 중...",
                    zeroRecords: "일치하는 결과가 없습니다.",
                    paginate: {
                        previous: "<i class='fa fa-chevron-left'></i>",
                        next: "<i class='fa fa-chevron-right'></i>"
                    }
                },
                processing: true,
                serverSide: true,
                ordering: false,
                pageLength: 100,
                lengthChange: false,
                searching: false
            });

            // 회원칸은 회원 팝오버가 연다(캐시내역도 그 메뉴에 있다). 칸에 따로 클릭을 걸고
            // 전파를 끊으면 팝오버 위임까지 막혀 눌러도 팝오버가 안 뜬다.

        }

        /**
         * 데이터 열에 따른 포맷 설정
         * @param row 열
         * @param data 데이터
         */
        function formatRow(row, data) {

            // 오더금액, 금액, 통장포인트 중앙 정렬
            $(row).find('td:nth-child(4), td:nth-child(10), td:nth-child(11)').addClass('text-left').css('text-align', 'right');
            $(row).find('td:nth-child(3), td:nth-child(10)').addClass('text-bold').css('font-weight', 'bold');

            // 오더번호 - 빨간 글씨
            $(row).find('td:nth-child(3)')
                .css('color', 'var(--adm-kw-navy, midnightblue)')
                .css('font-weight', 'bold')
                .css('font-size', '14px');

            // 회원칸 — 누를 곳은 안의 회원 링크(팝오버)뿐이라 칸 전체에 손가락 커서를 두지 않는다
            $(row).find('td:nth-child(5)')
                .css('color', 'var(--adm-kw-blue, blue)')
                .css('font-weight', 'bold')
                .css('font-size', '14px');

            // 금액 컬럼 (point) - 배경색 + 글자색
            const pointCell = $(row).find('td:nth-child(10)');
            pointCell.css('font-size','15px'); // 연한 파란 배경
            const pointValue = parseInt(data.point, 10);
            if (pointValue > 0) {
                pointCell.css('color', 'var(--adm-kw-blue, blue)');
            } else if (pointValue < 0) {
                pointCell.css('color', 'var(--adm-kw-red, red)');
            }

            // 일시 컬럼 - 연월일(파란색), 시간(갈색) 분리
            const datetimeCell = $(row).find('td:nth-child(2)');
            const [datePart, timePart] = data.datetime.split(' ');
            datetimeCell.html(
                `<span class="mc-date">${datePart}</span>
                <span class="mc-time">${timePart}</span>`
            );
            $(row).find('td').each(function (index) {
                const td = $(this);
                const textAlign = td.css('text-align');
                if (!textAlign || textAlign === 'left') {
                    td.css('text-align', 'center');
                }
            });

            const memCarTypeCell = $(row).find('td:nth-child(6)');
                const boxHtml = `<div class="mc-cartype">${data.mem_car_type}</div>`;
            memCarTypeCell.html(boxHtml);
        }

        /**
         * 엑셀 저장
         * @param tabname 테이블
         * @param fname 이름
         */
        function saveToExcel_ready(tabname, fname) {
            var adr = "/excel/cash/transactions";
            document.location.href = adr;
            // var win2=window.open(adr,'cache_toExcel','toolbar=no,status=no,WIDTH=1500,HEIGHT=900, directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no');
        }
    }
}
